import { Metamodel } from 'app/model/base/model';
import { compressionOptionValues } from 'app/shared/components/compression-setting/compression-options';

import { compressionCodecType, IValidationContext, IViolation, JsonDataset } from 'shell-models-lib';
import { StringDataFlowType } from '../dataflow-datatype';
import { DataFlowSink } from '../dataflow-sink';
import { DataFlowSource } from '../dataflow-source';
import { DataFlowExpression } from '../dataflowexpression';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { validateFilePathOfFileBasedSettings } from './dataset-settings-validation-utils';
import { FileBasedSettings, FILEMODE } from './file-based-settings';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.json.dataflowSettings,
    validator: JsonSettings.validateJsonSettings
})
export class JsonSettings extends FileBasedSettings {
    public compressionType: string;
    public compressionLevel: DataFlowExpression;
    public encoding: DataFlowExpression;

    public getDatasetType(): string {
        return Metamodel.modelFor(JsonDataset).name;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Json;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-20x20-Json';
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.compressionLevel = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, compressionOptionValues.Fastest);
        this.encoding = this.transform.createTemplatableExpression();
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateJsonSettings(settings: JsonSettings, context: IValidationContext): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        if (settings.transform instanceof DataFlowSource) {
            const source = settings.transform as DataFlowSource;
            if (source.isInlineDataset && source.datasetSettings && source.datasetSettings.getFormat() === DatasetFormatType.Json) {
                violations.push(...(await validateFilePathOfFileBasedSettings(settings, false, context)));
                if (settings.fileMode === FILEMODE.FILE && settings.compressionType === compressionCodecType.gzip &&
                    !settings.fileName.templateExpression && !!settings.fileName.expression && !settings.fileName.expression.endsWith('.gz')) {
                    violations.push({
                        message: () => stringResources.Dataset_FileFormat_GZipFilenameError,
                        context: source
                    });
                }
            }
        }
        if (settings.transform instanceof DataFlowSink) {
            const sink = settings.transform as DataFlowSink;
            if (sink.isInlineDataset && sink.datasetSettings && sink.datasetSettings.getFormat() === DatasetFormatType.Json) {
                violations.push(...(await validateFilePathOfFileBasedSettings(settings, true, context)));
            }
        }
        return violations.length > 0 ? violations : undefined;
    }
}
